export const PathwayStateTypeLabelMap = {
    admit: 'Admission',
    initial: 'Initial',
    reassess: 'Reassessment',
    discharge: 'Discharge',
    assessment: 'Assessment',
    consult: 'Consult',
};
//# sourceMappingURL=consts.js.map